import * as missionApi from "../../api/missionApi";
import StateIcon from "../StateIcon";
import TimeDisplay from "../TimeDisplay";

export default function DroneCollectStatusMessage(props) {
    return (
        <span>
            <StateIcon
                state={missionApi.getFlightState(props.flight)}
                className={"me-4"}
            />
            Flight by {props.flight?.drone?.id || "some drone"} at{" "}
            <TimeDisplay
                timestamp={props.flight.timestamp.seconds}
                format="HH:mm:ss"
                organizationId={props.organizationId}
                locationId={props.locationId}
            />
        </span>
    );
}
